/**
 * Διάταξη της διαχείρισης καταστήματος: μενού (StoreNavigation) + περιεχόμενο.
 *
 * - Κλασική εμφάνιση: ΑΚΡΙΒΩΣ ό,τι υπήρχε — οριζόντιες καρτέλες από πάνω και από κάτω
 *   <div className="w-full px-4 py-4">. Το Fragment δεν προσθέτει τίποτα στο DOM.
 * - Νέα εμφάνιση (md+): πλαϊνό μενού αριστερά, περιεχόμενο δεξιά. Η στήλη του μενού
 *   τεντώνεται σε όλο το ύψος της σελίδας (φόντο/περίγραμμα) και το εσωτερικό της μένει
 *   κολλημένο στην οθόνη (βλ. StoreNavigation). Στο κινητό μένει η μπάρα με το συρτάρι.
 *
 * Το χρησιμοποιεί μόνο το StoreAdminDashboard· τα παλιά «Προϊόντα» (/products) είναι πια η
 * καρτέλα «Κατάλογος» μέσα σε αυτό (το /products ανακατευθύνει εκεί, βλ. App.tsx).
 */
import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import StoreNavigation from './StoreNavigation';

interface StoreAdminLayoutProps {
  activeTab: string;
  onTabClick: (tab: string) => void;
  children: React.ReactNode;
}

const StoreAdminLayout: React.FC<StoreAdminLayoutProps> = ({ activeTab, onTabClick, children }) => {
  const { look } = useTheme();

  if (look !== 'v2') {
    return (
      <>
        <StoreNavigation activeTab={activeTab} onTabClick={onTabClick} />
        <div className="w-full px-4 py-4">{children}</div>
      </>
    );
  }

  return (
    <div className="md:flex">
      <StoreNavigation activeTab={activeTab} onTabClick={onTabClick} />
      <div className="w-full min-w-0 flex-1 px-4 py-4 md:px-6 md:py-5">{children}</div>
    </div>
  );
};

export default StoreAdminLayout;
